/*
 #version: 1.20150717

 lib dependencies
 - imagesloaded
*/
;var lmnModal = (function($)
{
	//module vars
	var _initialized = false,
		_libs = {
			imagesloaded: false
		},
		_settings = {
			html: '',
			modal_class: '',
			has_images: true,
			fixonfit: false,
			closable: true,
			events: {} // afterinit | beforeopen | afteropen | imagesloaded | beforeclose | afterclose | beforeresize | afterresize
		},

		_$doc = null,
		_$body = null,
		_$win = null,

		_$cover = jQuery('<div id="lmnmodal_cover"></div>'),
		_$modal = jQuery('<div id="lmnmodal_modal"></div>'),
		_$content = jQuery('<div id="lmnmodal_content"></div>'),

		_is_open = false,

		_has_console = typeof window.console !== 'undefined',

		_log_events = false;

	//module functions
	function _init()
	{
		_initialized = true;

		_libs.imagesloaded = typeof imagesLoaded == 'function';

		_$doc = $(document);
		_$body = $('body');
		_$win = $(window);

		_$body.append(_$cover, _$modal);
		_$modal.append(_$content);

		_$doc.on('keyup', function(e) { if (e.keyCode == 27 && _is_open) { lmnModal.close(); } });
		_$cover.on('click', function(e) { lmnModal.close(); });

		_doEvent('afterinit');
	}

	function open(settings)
	{
		if (!_initialized) _init();

		//new popup, reset events
		_settings.events = {};

		applySettings(settings);
		_$modal.addClass(settings.modal_class);

		_doEvent('beforeopen');

		setContent(settings);

		_$cover.show();
		_$modal.show();
		_is_open = true;

		_$win.on('resize orientationchange', function(e) { lmnModal.resize('window_resize'); });

		_$modal.on('click', '.js-lmnmodal-close', function(e) { e.preventDefault(); lmnModal.close(); });

        resize();

		_doEvent('afteropen');

		return _$modal;
	}

	function setContent(settings)
	{
		if (typeof settings == 'string') settings = { html: settings };
		applySettings(settings);

		if (_settings.has_images && !_libs.imagesloaded && _has_console) console.warn('imagesLoaded js not loaded');

		_$content.html(_settings.html);
		resize();

		if (_settings.has_images && _libs.imagesloaded)
		{
			imagesLoaded(_$modal, function(instance)
			{
				resize();
				_doEvent('imagesloaded');
			});
		}
	}

	function applySettings(settings)
	{
		_settings = jQuery.extend(true, {}, _settings, settings);
	}

	function close()
	{
		if (!_settings.closable) return;

		_doEvent('beforeclose');

		_$content.html('');
		_$cover.hide();
		_$modal.hide();
		_is_open = false;

		_doEvent('afterclose');
	}

	function forceClose()
	{
		_settings.closable = true;
		close();
	}

	function resize(trigger)
	{
		if (!_is_open || (trigger == 'window_resize' && _$win.width() < 480)) return;

		_doEvent('beforeresize');

		//for correct measurements
		_$modal.addClass('no_height');
		_$modal.css({ top: 0, left: 0 });

		var content_w = _$content.outerWidth();
		var content_h = _$content.outerHeight();
		var win_w = _$win.width();
		var win_h = window.innerHeight ? window.innerHeight : _$win.height();

		var scrollpos = _$doc.scrollTop();

		var view_center_y = scrollpos + (win_h/2);
		var view_center_x = win_w/2;

		var pos_x = view_center_x - (content_w/2);
		var pos_y = view_center_y - (content_h/2);
		if (pos_y < scrollpos) pos_y = scrollpos;

		//console.log(scrollpos);
		//console.log(win_h);
		//console.log(content_h);
		//console.log(view_center_y);
		//console.log(pos_y);

		_$modal.css({ top: pos_y, left: pos_x });
		_$modal.removeClass('no_height');

		_doEvent('afterresize');

	}

	function _doEvent(event_string)
	{
		var prefix = 'lmnmodal.';
		_$doc.trigger(prefix+event_string);

		if (typeof _settings.events[event_string] == 'function') _settings.events[event_string](_$modal);

		if (_log_events) console.log(prefix+event_string);
	}

	function logSettings()
	{
		console.log(_settings);
	}

	function logEvents(log_events)
	{
		_log_events = log_events;
	}

	//reveal public vars and functions
	return {
		//vars

		//functions
		open: open,
		close: close,
		forceClose: forceClose,
		resize: resize,
		setContent: setContent,
		applySettings: applySettings,
		logSettings: logSettings,
		logEvents: logEvents
	};

})(jQuery);
